import { combineReducers } from 'redux';
import { persistReducer, createMigrate } from 'redux-persist';
import { MigrationManifest } from 'redux-persist/es/types';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { connectRouter, ConnectedRouter } from 'connected-react-router';
import { History } from 'history';
import modal, { ModalState } from './modal';
import info, { InfoState, initialState as infoInitialState } from './info';
import data, { DataState, initialState as dataInitialState } from './data';
import auth, { AuthState, initialState as authInitialState } from './auth';
import deviceData, { DeviceDataState, initialState as deviceDataInitialState } from './deviceData';

const merge = (state: RootState) => ({
  ...state,
  auth: { ...authInitialState, ...state.auth },
  data: { ...dataInitialState, ...state.data },
  info: { ...infoInitialState, ...state.info },
  deviceData: { ...deviceDataInitialState, ...state.deviceData },
});
const mergeForceResetData = (state: RootState) => ({
  ...state,
  auth: { ...authInitialState, ...state.auth },
  data: { ...dataInitialState },
  info: { ...infoInitialState, ...state.info },
  deviceData: { ...deviceDataInitialState, ...state.deviceData },
});
// Redux-persist migrations.
// Add a new key with an upgraded version number and then increase the version number with any additional migrations that are needed
// https://www.freecodecamp.org/news/how-to-use-redux-persist-when-migrating-your-states-a5dee16b5ead/
const migrations = {
  0: merge,
  1: merge,
  2: mergeForceResetData,
  3: merge,
  4: merge,
  5: merge,
  6: merge,
  7: mergeForceResetData,
};
export const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['router', 'modal'],
  version: 7,
  migrate: createMigrate(migrations as unknown as MigrationManifest, { debug: false }),
};

const rootReducer = (history: History) =>
  persistReducer(
    persistConfig,
    combineReducers({
      auth,
      modal,
      data,
      info,
      router: connectRouter(history),
      deviceData,
    }),
  );

export type RootState = {
  auth: AuthState;
  data: DataState;
  modal: ModalState;
  info: InfoState;
  router: ConnectedRouter<History>;
  deviceData: DeviceDataState;
};
export default rootReducer;
